
/**
 * @nullable
 */
export type CreateNotificationBodyMetadata = {[key: string]: string} | null;
